// src/components/EmailInbox.js
import React, { useState, useEffect } from "react";
import { List, Modal, Button, Layout, Badge, Avatar, Checkbox, Pagination } from 'antd';
import './EmailInbox.scss';
import { useDispatch, useSelector } from "react-redux";
import emailActions from "../../redux/communication_channel/actions";

const { getMailsData, updateEmailRead } = emailActions;
const { Content } = Layout;

const EmailInbox = () => {
  const dispatch = useDispatch();
  const [tableParams, setTableParams] = useState({ current: 1, pageSize: 10 });
  const { emails, totalData, loading } = useSelector((state) => state?.communicationReducer);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [forceUpdateCheckbox, setForceUpdateCheckbox] = useState(false);
  const { profileData } = useSelector(state => state.authReducer);

  useEffect(() => {
    dispatch(getMailsData(tableParams.current, tableParams.pageSize, "", "", "", profileData?.orgId));
  }, [dispatch, tableParams.current, tableParams.pageSize , profileData]);

  const handlePageChange = (page, pageSize) => {
    setTableParams({ current: page, pageSize });
  };

  const openEmail = (email) => {
    setSelectedEmail(email);
    const data = {
      isRead: true,
      ids: [email?._id]
    };
    dispatch(updateEmailRead(data , profileData?.orgId));
  };
  

  const handleSelectAll = (e) => {
    // console.log(e , "e e ee e")
    setForceUpdateCheckbox(!forceUpdateCheckbox);
    if (e.target.checked) {
      setSelectedEmails(emails?.map(email => email?._id));
    } else {
      setSelectedEmails([]);
    }
  };

  const handleSelectEmail = (emailId) => {
    setSelectedEmails(prev => 
      prev.includes(emailId) 
      ? prev.filter(id => id !== emailId) 
      : [...prev, emailId]
    );
  };

  const markAsRead = async () => {
    const data = {
      isRead: true,
      ids: selectedEmails,
    };
    const response = await dispatch(updateEmailRead(data , profileData?.orgId));
    setSelectedEmails([]);
    setForceUpdateCheckbox(!forceUpdateCheckbox);
    dispatch(getMailsData(tableParams.current, tableParams.pageSize, "", "", "", profileData?.orgId));
  };

  const modelClose = () => {
    setSelectedEmail(null);
    dispatch(getMailsData(tableParams.current, tableParams.pageSize, "", "", "", profileData?.orgId));
  };

  return (
    <Layout style={{ height: '100vh' }} loading={loading}>
      <Layout style={{ padding: '0 10px 10px' }}>
        <div className="header-content">
          <h2>Email Client</h2>
          <Pagination
            current={tableParams?.current}
            total={totalData}
            pageSize={tableParams?.pageSize}
            onChange={handlePageChange}
            pageSizeOptions={[10, 20, 50]}
            showQuickJumper={true}
            showSizeChanger={true}
          />
        </div>
        <Content>
          <Checkbox
            style={{ padding: "0 20px" }}
            checked={selectedEmails?.length === emails?.length && emails?.length !== 0}
            onChange={handleSelectAll}
            key={forceUpdateCheckbox} 
          />
          <Button onClick={markAsRead} disabled={selectedEmails?.length === 0}>
            Mark as Read
          </Button>
          <List
            itemLayout="horizontal"
            dataSource={Array.isArray(emails) ? emails : []}
            renderItem={email => (
              <List.Item
                key={email._id}
                className={`email-item ${email?.isRead ? 'read' : 'unread'}`}
                style={{ padding: "10px 20px", alignItems: "center" }}
              >
                <Checkbox
                  style={{ paddingRight: "5px" }}
                  checked={selectedEmails?.includes(email._id)}
                  onChange={() => handleSelectEmail(email._id)}
                />
                {!email.isRead ? <Badge style={{ paddingRight: "5px" }} status="processing" /> : <Badge style={{ paddingRight: "5px" }} status="success" />}
                <List.Item.Meta
                  onClick={() => openEmail(email)}
                  style={{ display: 'flex', alignItems: 'center' }}
                  avatar={<Avatar>{email.email[0].toUpperCase()}</Avatar>}
                  title={
                    <div style={{ display: 'flex', alignItems: 'center', columnGap: '30px' }}>
                      <span><strong>Subject:</strong> {email.subject}</span>
                      <span style={{ flexGrow: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{email.body}</span>
                    </div>
                  }
                  description={null}
                />
                <div>{new Date(email.sentAt).toLocaleString()}</div>
              </List.Item>
            )}
          />
        </Content>
      </Layout>
      {selectedEmail && (
        <Modal
          title={<strong>From: {selectedEmail?.email}</strong>}
          open={!!selectedEmail}
          onCancel={modelClose}
          footer={[
            <Button key="back" onClick={modelClose}>
              Close
            </Button>,
          ]}
        >
          <p><strong>Subject:</strong> {selectedEmail.subject}</p>
          <p><strong>Body:</strong> {selectedEmail.body}</p>
          {selectedEmail?.attachments && selectedEmail?.attachments?.length > 0 && (
            <div>
              <strong>Attachments:</strong>
              <ul>
                {selectedEmail.attachments.map((attachment, index) => (
                  <li key={index}><a href={attachment} target="_blank" rel="noopener noreferrer">{attachment}</a></li>
                ))}
              </ul>
            </div>
          )}
        </Modal>
      )}
    </Layout>
  );
};

export default EmailInbox;
